export default __webpack_public_path__ + "b00162c05c6faa59400324a4473d739a.png";